<script lang="ts">
  /** Renders the toast queue at the top-right of the viewport. Mounted
   *  once in App.svelte so any module can push toasts via the store. */
  import { fly } from 'svelte/transition';
  import { dismissToast, toasts } from '$domain/toasts.svelte';
</script>

<div class="toast-host" aria-live="polite" aria-atomic="false">
  {#each toasts.list as t (t.id)}
    <div
      class="toast k-{t.kind}"
      in:fly={{ x: 16, duration: 180 }}
      out:fly={{ x: 16, duration: 140 }}
    >
      <span class="t-msg">{t.message}</span>
      {#if t.action}
        <button
          type="button"
          class="t-action"
          onclick={() => {
            t.action!.onClick();
            dismissToast(t.id);
          }}
        >
          {t.action.label}
        </button>
      {/if}
      <button type="button" class="t-x" aria-label="dismiss" onclick={() => dismissToast(t.id)}>
        ×
      </button>
    </div>
  {/each}
</div>

<style>
  .toast-host {
    position: fixed;
    top: var(--space-4);
    right: var(--space-4);
    z-index: var(--z-toast);
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    max-width: min(420px, 92vw);
    pointer-events: none;
  }
  .toast {
    pointer-events: auto;
    display: flex;
    align-items: flex-start;
    gap: var(--space-3);
    background: var(--bg-elev-2);
    border: 1px solid var(--border);
    border-left-width: 3px;
    border-radius: var(--radius-2);
    padding: var(--space-3) var(--space-4);
    font-size: var(--text-sm);
    line-height: var(--leading-base);
    color: var(--fg);
    box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.5);
  }
  .k-info {
    border-left-color: var(--accent-2);
  }
  .k-success {
    border-left-color: oklch(0.74 0.18 145);
  }
  .k-warn {
    border-left-color: oklch(0.84 0.18 90);
  }
  .k-error {
    border-left-color: oklch(0.62 0.21 25);
  }
  .t-msg {
    flex: 1;
  }
  .t-action {
    appearance: none;
    background: transparent;
    border: 1px solid var(--border);
    color: var(--accent);
    font: inherit;
    font-size: 11px;
    font-family: var(--font-mono);
    letter-spacing: 0.04em;
    padding: 2px 8px;
    border-radius: var(--radius-2);
    cursor: pointer;
    white-space: nowrap;
  }
  .t-action:hover {
    background: var(--bg-elev-3);
    border-color: var(--accent);
  }
  .t-action:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
  }
  .t-x {
    background: transparent;
    border: 0;
    color: var(--fg-subtle);
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
  }
  .t-x:hover {
    color: var(--fg);
  }
</style>
